<template>
  <div>
    <v-row>
      <v-col>
        <h4>{{ $t('host.label.asaasAccount') }}</h4>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <h6 class="text-uppercase grey--text">
          {{ $t('host.label.asaas.walletId') }}
        </h6>
        <div class="d-flex align-center">
          <span class="body-2">
            {{ data.asaas_account.wallet_id }}
          </span>
          <CopyToClipboard :value="data.asaas_account.wallet_id" />
        </div>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <h6 class="text-uppercase grey--text">
          {{ $t('host.label.asaas.accountStatus') }}
        </h6>
        <span class="body-2">
          {{ data.asaas_account.status ? $t(`host.label.asaas.status.${data.asaas_account.status}`) : '---' }}
        </span>
      </v-col>
      <v-col>
        <h6 class="text-uppercase grey--text">
          {{$t('host.label.createdAt')}}
        </h6>
        <span class="body-2">
          {{ data.asaas_account.date_created ? formatDateWithoutTime(data.asaas_account.date_created) : '---' }}
        </span>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { catalogDate, catalogPhone, catalogDateWithoutTime } from '@/util/catalog'
import { formatDocument } from '@/util/document'
import CopyToClipboard from '@/components/app/CopyToClipboard'

export default {
  name: 'HostAsaasAccount',

  components: {
    CopyToClipboard
  },

  props: {
    data: {
      type: Object,
      required: true,
    }
  },

  data() {
    return {
      formatDocument,
      dateTime: catalogDate,
      formatDateWithoutTime: catalogDateWithoutTime,
      formatPhone: catalogPhone,
    }
  }
}
</script>
